import { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const iconButtonSx: SxProps<Theme> = {
  width: 36,
  height: 36,
  borderRadius: '50%',
  color: Color.white,
  transition: 'background-color 0.2s ease, color 0.2s ease',
  '&:hover': {
    backgroundColor: Color.primaryOrange,
    color: Color.black,
  },
  '&:disabled': {
    color: Color.gray,
  },
};

export const disabledIconButtonSx: SxProps<Theme> = {
  ...iconButtonSx,
  color: Color.gray,
  '&:hover': {
    backgroundColor: 'transparent',
    color: Color.gray,
  },
};

export const mobileMenuItemSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  py: 1.5,
  px: 2.5,
  '&:hover': {
    backgroundColor: Color.blackWithOpacity,
  },
  '& .MuiListItemIcon-root': {
    color: Color.black,
  },
};

export const desktopActionsSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  marginRight: 2,
};

export const mobileContainerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const disabledMobileMenuItemSx: SxProps<Theme> = {
  ...mobileMenuItemSx,
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& .MuiListItemText-primary': {
    color: Color.blackMuted,
  },
  '& .MuiListItemIcon-root': {
    color: Color.blackMuted,
  },
};
